import React from "react";
import {
    EonUiAccordion,
    EonUiAccordionPane,
    EonUiBulletList,
    EonUiBulletListItem,
} from "@eon-ui/eon-ui-components-react";
import { AboutUsPageData } from "./AboutUsPageData";
import { useTranslation } from "@me8eon/translation";
const ReleaseNotes: React.FC = () => {
    const { t, i18n } = useTranslation("about-us");
    const me8eonHeading = t("releaseNotes.accordianHeading");
    const myHelpHeading = t("releaseNotes.accordianMyHelpHeading");
    const myHelpNewHeading = t("releaseNotes.accordianMyHelpNewHeading")

    return (
        <EonUiAccordion
            mode="single"
            key={i18n.language}
            data-testid="releaseNotes"
        >
            {AboutUsPageData.slice()
                .reverse()
                .map((notes, notesKey) => {
                    const versionNum = notes.version.replace(/\./g, "");
                    const heading = Number(versionNum) < 320 ? me8eonHeading : (Number(versionNum) > 699 ? myHelpNewHeading : myHelpHeading);

                    return (
                        <EonUiAccordionPane
                            pane-title={heading.replace("<version>", notes.version)}
                            slot={heading.replace("<version>", notes.version)}
                            key={`${notes.version} - ${notesKey.toString()}`}
                        >
                            <div className="release-date">{notes.date}</div>
                            <EonUiBulletList iconName="bulletlist_square">
                                {notes.content[i18n.language].map(
                                    (content, key) => (
                                        <EonUiBulletListItem
                                            text={content}
                                            highlight={false}
                                            key={`${content} - ${key.toString()}`}
                                        ></EonUiBulletListItem>
                                    )
                                )}
                            </EonUiBulletList>
                        </EonUiAccordionPane>
                    )
                })}
        </EonUiAccordion>
    );
};

export default ReleaseNotes;
